class GoogleDataLayerProvider {
  constructor(orderData = {}, productData = {}, sessionData = {}) {
    const googleDataLayerDefaults = {
      cartItems: [],
    };

    this.data = Object.assign(googleDataLayerDefaults, orderData);

    this.productData = productData;

    this.sessionData = sessionData;
  }

  getSession() {
    const { sessionData } = this;

    return {
      session: {
        key: sessionData.sessionKey,
        isRenewalOrder: sessionData.isRenewalOrder,
        modeOfSale: sessionData.modeOfSale,
        sourceId: sessionData.sourceId,
        version: window.tnew.app.appVersion.toString(),
        customer: {
          id: sessionData.customerNumber,
          isGuest: sessionData.isGuest,
          isAnonymous: sessionData.isAnonymous,
        },
      },
    };
  }

  getProduct() {
    const product = this.productData;

    return {
      product: {
        productTypeDescription: product.productTypeDescription,
        productionSeasonId: product.productionSeasonId,
        performanceId: product.performanceId,
        packageId: product.packageId,
        contributionTypeId: product.contributionTypeId,
        fundId: product.fundId,
        onAccountPaymentMethodId: product.onAccountPaymentMethodId,
        giftCertificatePaymentMethodId: product.giftCertificatePaymentMethodId,
        membershipId: product.membershipLevelId,
      },
    };
  }

  transformOrder() {
    if (this.data.cartItems.length === 0) {
      return {};
    }

    const convertedProducts = this.convertProducts();
    const { data } = this;

    return {
      transactionId: data.number,
      transactionAffiliation: data.modeOfSale,
      transactionTotal: data.total,
      transactionTax: 0,
      transactionProducts: convertedProducts,
      transactionShipping: data.fees,
    };
  }

  convertProducts() {
    const products = {};
    const { cartItems } = this.data;

    cartItems.forEach((cartItem) => {
      const key = `${cartItem.productId}-${cartItem.priceType}-${cartItem.price}`;

      if (products[key]) {
        products[key].quantity += cartItem.quantity;
      } else {
        products[key] = {
          sku: cartItem.sku,
          name: cartItem.productDescription,
          category: cartItem.productType,
          price: cartItem.price,
          quantity: cartItem.quantity,
        };
      }
    });

    return Object.values(products);
  }
}

export default GoogleDataLayerProvider;
